document.addEventListener('DOMContentLoaded', function () {
    const promoMessageId = 'socks-promo-message';

    function createPromoMessage() {
        let promoMessage = document.getElementById(promoMessageId);
        if (!promoMessage) {
            promoMessage = document.createElement('div');
            promoMessage.id = promoMessageId;
            promoMessage.textContent = 'SOCK PROMO: Buy 4 Pairs, Get 5th & Cheapest Pair FREE! (ADD 5 to CART)';
            promoMessage.style.display = 'none'; // Hidden by default
            promoMessage.style.backgroundColor = '#ffea00';
            promoMessage.style.padding = '10px';
            promoMessage.style.textAlign = 'center';
            document.body.appendChild(promoMessage); // Adjust the placement if needed
        }
        return promoMessage;
    }

    async function checkCartForSocksTag() {
        try {
            const promoMessage = createPromoMessage();
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();

            const productFetches = cart.items.map(item =>
                fetch(`/products/${item.handle}.js`).then(response => response.json())
            );

            const products = await Promise.all(productFetches);

            const socksTagFound = products.some(product =>
                product.tags.includes('Socks')
            );

            // Toggle message based on the presence of the 'Socks' tag
            promoMessage.style.display = socksTagFound ? 'block' : 'none';
        } catch (error) {
            console.error('Error checking cart for socks tag:', error);
        }
    }

    // Initial cart check on page load
    checkCartForSocksTag();

    // Listen for cart updates
    document.addEventListener('cart:updated', checkCartForSocksTag);

    // Directly hook into the Shopify AJAX cart events if available
    if (typeof Shopify !== 'undefined' && Shopify.onItemAdded) {
        Shopify.onItemAdded = function () {
            checkCartForSocksTag();
        };
    }

    // Override fetch to detect cart changes directly
    const originalFetch = window.fetch;
    window.fetch = async function (resource, options) {
        const response = await originalFetch(resource, options);

        // Check if the request is a cart update
        if (resource.includes('/cart/add') || resource.includes('/cart/update') || resource.includes('/cart/change')) {
            setTimeout(() => {
                checkCartForSocksTag();
            }, 500); // Adjust the delay as needed
        }

        return response;
    };
});
